import {
    TRANSACTIONS_FETCH,
    TRANSACTIONS_IS_FETCING,
    TRANSACTIONS_API,
    TRANSACTION_EDIT,
    TRANSACTION_FILTER,
    SET_TRANSACTION_VIEW_FILTER,
    UPDATE_TRANSACTION_STATUS
} from 'constants/transactions'

//HTTP reuests actions
import {
    put,
    post,
    remove,
    get
} from 'actions/requests'

export const transactionSave = (data) => (dispatch, state) => {
    let action;
    if (data.transactionId)
        action = put;
    else
        action = post;
    dispatch(transactionsIsFetching(true))
    return action(TRANSACTIONS_API, data)
        .then((e) => { dispatch(transactionsIsFetching(false)); return e; })
        .catch((e) => { dispatch(transactionsIsFetching(false)); throw new Error(e) })
}

export const transactionFetch = (id) => (dispatch, state) => {
        dispatch(transactionsIsFetching(true));
        return get(TRANSACTIONS_API + '/' + id)
            .finally(e => dispatch(transactionsIsFetching(false)))

    }

export const transactionsFetch = (ibId=null, from=null, to=null, destination=null, status=null, loading=true) => (dispatch, state) => {
    dispatch(transactionsIsFetching(loading));
    const filter = state().transactions.pageable
    const sorted = Object.keys(filter.sort).find(e => filter.sort[e])
    let params = {
            size: filter.size,
            page: filter.page,
            sort: sorted + ',' + filter.sort[sorted]
        };

    if ((ibId !== undefined) && ((ibId !== null) && (ibId !== 0))) {
        params.ibid = ibId;
    }
    if ((from !== undefined) && (from !== null)) {
        params.from = from;
    }
    if ((to !== undefined) && (to !== null)) {
        params.to = to;
    }
    if ((destination !== undefined) && (destination !== null) && (destination !== 0)) {
        params.destination = destination;
    }

    if ((status !== undefined) && (status !== null)) {
        params.status = status;
    }

    return get(TRANSACTIONS_API, params)
        .then((e) => {
            dispatch(transactionsFetched(e.content))
            return e
        })
        .then((e) => {
            dispatch(
                transactionFilter({
                    totalPages: e.totalPages
                })
            )
            return e
        })
        //disable loading
        .finally(e => dispatch(transactionsIsFetching(false)))
}

export const declineTransaction = (id) => (dispatch, state) => {
	dispatch(transactionsIsFetching(true))
    return post(TRANSACTIONS_API + '/decline/' + id)
            .then((data) => dispatch(updateTransactionStatus(data)))
			.finally(e => dispatch(transactionsIsFetching(false)))
}

export const approveTransaction = (id) => (dispatch, state) => {
	dispatch(transactionsIsFetching(true))
    return post(TRANSACTIONS_API + '/approve/' + id)
            .then((data) => dispatch(updateTransactionStatus(data)))
			.finally(e => dispatch(transactionsIsFetching(false)))
}

export const transactionRemove = (id) => (dispatch, state) => {
    dispatch(transactionsIsFetching(true))
    return remove(TRANSACTIONS_API + '/' + id)
        .then((e) => {
            dispatch(transactionsIsFetching(false));
            return e;
        }).catch((e) => { dispatch(transactionsIsFetching(false)); console.log('eee', e); throw new Error(e) })
        .finally(e => dispatch(transactionsIsFetching(false)))
}

export const transactionsFetched = (payload) => ({ type: TRANSACTIONS_FETCH, payload: payload })
export const transactionsIsFetching = (payload) => ({ type: TRANSACTIONS_IS_FETCING, payload: payload })
export const transactionEdit = (id, data) => ({ type: TRANSACTION_EDIT, payload: data })
export const transactionFilter = (data) => ({ type: TRANSACTION_FILTER, payload: data })
export const setTransactionViewFilter = (data) => ({ type: SET_TRANSACTION_VIEW_FILTER, payload: data })
export const updateTransactionStatus = (data) => ({type: UPDATE_TRANSACTION_STATUS, payload: data})


// WEBPACK FOOTER //
// ./src/actions/transactions.js